const postLogoutRedirect = () => {
    const a = document.querySelector("a.PostLogoutRedirectUri");
    if (a) {
        window.location = a.href;
    }
};

window.addEventListener("DOMContentLoaded", postLogoutRedirect);

